import React, { useMemo } from 'react'
import { QRCodeCanvas } from 'qrcode.react'
import useSession from '../../../session/useSession'
import useViewport from '../../../modules/viewport/useViewport'
import useInterfaceLocale from '../../../modules/locale/useInterfaceLocale'
import PreviewModule from '../../../modules/preview/Module'

import style from './DeviceSwitchLink.module.scss'

interface IDeviceSwitchLinkProps {
  showQR?: boolean
  className?: string
}

const DeviceSwitchLink: React.FC<IDeviceSwitchLinkProps> = ({ showQR = false, className }) => {
  const session = useSession()
  const viewport = useViewport()
  const { t } = useInterfaceLocale()

  const redirectUrl = viewport.emulated && window.parent ? window.parent.location.href : window.location.href

  const isModalPreview = useMemo(() => session.action.preview && PreviewModule.closeable, [session.action.preview])

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Prevent link click in modal preview
    if (isModalPreview) {
      e.preventDefault()
      return
    }

    // If in iframe, reload parent window instead of iframe
    if (viewport.emulated && window.parent) {
      e.preventDefault()
      window.parent.location.href = redirectUrl
    }
  }

  return (
    <>
      <a
        href={redirectUrl}
        onClick={handleLinkClick}
        className={[className, isModalPreview && style.disabledLink].filter(Boolean).join(' ')}
      >
        {redirectUrl}
      </a>
      {isModalPreview && (
        <div className={style.modalPreviewWarning}>{t('questions', 'instruction', 'modalPreviewWarning')}</div>
      )}
      {showQR && (
        <div className={style.qrCode}>
          <QRCodeCanvas value={redirectUrl} size={150} />
        </div>
      )}
    </>
  )
}

export default DeviceSwitchLink
